import './SubscribeDialog.scss'

import { isInactiveSub, isInactiveTrial } from 'lib/client/360-subscriptions'
import { isActiveTrial, isNonSeatHoldingAdmin, isTrial } from 'lib/client/360-subscriptions/subscription'
import Button from 'lib/components/Button/Button'
import Dialog from 'lib/components/Dialog/Dialog'
import AuthContext from 'lib/context/AuthContext'
import SubContext from 'lib/context/SubContext'
import { isLoggedIn } from 'lib/util/self'
import { addTeamMemberUrl, freeTrialUrl, purchase360Url, teamManagementUrl } from 'lib/util/urls'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import Anchor from '../Anchor/Anchor'

export interface SubscribeDialogProps {
  onRequestClose?: ()=> void
  onClickSignIn?: ()=> void
}

export default function SubscribeDialog(props: SubscribeDialogProps) {
  const { onRequestClose, onClickSignIn } = props
  const { self, login } = useContext(AuthContext)
  const userSubStatus = useContext(SubContext)
  const [t] = useTranslation()

  function renderBody() {
    if (isInactiveTrial(userSubStatus)) {
      return t('home.subscribeDialog.expiredTrialBody')
    }

    if (isInactiveSub(userSubStatus)) {
      return t('home.subscribeDialog.expiredSubBody')
    }

    if (isNonSeatHoldingAdmin(userSubStatus)) {
      if (isActiveTrial(userSubStatus.adminRole)) {
        return t('home.subscribeDialog.nonSeatHoldingAdminActiveTrialBody')
      }

      return t('home.subscribeDialog.nonSeatHoldingAdminBody')
    }

    return t('home.subscribeDialog.body')
  }

  function handleClickSignIn() {
    if (onClickSignIn) {
      onClickSignIn()
    }
    login()
  }

  function renderButtons() {
    if (isInactiveTrial(userSubStatus) || isInactiveSub(userSubStatus)) {
      return (
        <>
          <Button size="small" variant="secondary" onClick={onRequestClose}>
            {t('home.subscribeDialog.cancelButton')}
          </Button>
          <Anchor size="small" href={purchase360Url()}>
            {t('home.subscribeDialog.buyButton')}
          </Anchor>
        </>
      )
    }

    if (isNonSeatHoldingAdmin(userSubStatus)) {
      // TODO analytic event with tracking code
      const addNowUrl = isTrial(userSubStatus.adminRole)
        ? addTeamMemberUrl(userSubStatus.adminRole.id)
        : teamManagementUrl(userSubStatus.adminRole.id)

      return (
        <>
          <Button size="small" variant="secondary" onClick={onRequestClose}>
            {t('home.subscribeDialog.cancelButton')}
          </Button>
          <Anchor size="small" href={addNowUrl}>
            {t('home.subscribeDialog.addNowButton')}
          </Anchor>
        </>
      )
    }

    return (
      <>
        <Anchor size="small" variant="secondary" href={freeTrialUrl()}>
          {t('home.subscribeDialog.startTrialButton')}
        </Anchor>
        <Anchor size="small" href={purchase360Url()}>
          {t('home.subscribeDialog.buyButton')}
        </Anchor>
      </>
    )
  }

  return (
    <Dialog className="subscribe-dialog" onRequestClose={onRequestClose}>
      <Dialog.Header onRequestClose={onRequestClose}>
        <Dialog.Title>
          {isNonSeatHoldingAdmin(userSubStatus)
            ? t('home.subscribeDialog.nonSeatAdminHeader')
            : t('home.subscribeDialog.header')}
        </Dialog.Title>
      </Dialog.Header>
      <Dialog.Body>{renderBody()}</Dialog.Body>
      <Dialog.Footer>
        <div className="subscribe-dialog__button-row">{renderButtons()}</div>
        {!isLoggedIn(self) && (
          <Button className="subscribe-dialog__sign-in" variant="link" onClick={handleClickSignIn}>
            {t('home.subscribeDialog.signInButton')}
          </Button>
        )}
      </Dialog.Footer>
    </Dialog>
  )
}
